/* VAN LYNN — localization.js
   Submits Shopify's native localization form when a country or language is chosen. */
(function () {
  'use strict';
  if (customElements.get('localization-form')) return;
  customElements.define(
    'localization-form',
    class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-autosubmit]').forEach((select) => {
          select.addEventListener('change', () => {
            const form = this.querySelector('form');
            if (form) form.submit();
          });
        });
      }
    }
  );
})();
